import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

interface Client {
    slug: string;
    name: string;
    domain: string;
    vhost: string;
    color: string;
    logo: string;
}

@Injectable({
    providedIn: 'root'
})
export class AccessService {

    clientLoaded : Subject<boolean> = new Subject<boolean>();

    private _token: string = '';
    private _client: Client|null = null;

    get token() {
        return this._token;
    }

    set token(token: string) {
        this._token = token;
    }

    set client(client: any) {
        this._client = client;
        this.clientLoaded.next(true);

        // set global background gradient from client color to slightly darker
        const darkerColor = this.darkenColor(client.color, 40);
        document.body.style.background = `linear-gradient(135deg, ${client.color} 0%, ${darkerColor} 100%)`;
        document.body.style.minHeight = '100vh';
    }

    private darkenColor(color: string, percent: number): string {
        // Convert hex to RGB
        const hex = color.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Darken by reducing each channel
        const darkenedR = Math.max(0, Math.floor(r * (1 - percent / 100)));
        const darkenedG = Math.max(0, Math.floor(g * (1 - percent / 100)));
        const darkenedB = Math.max(0, Math.floor(b * (1 - percent / 100)));

        // Convert back to hex
        return `#${darkenedR.toString(16).padStart(2, '0')}${darkenedG.toString(16).padStart(2, '0')}${darkenedB.toString(16).padStart(2, '0')}`;
    }

    get client() {
        return this._client;
    }
}
